<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="panPublishProcess">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="编号：">
            <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
          </vm-search>
          <vm-search label="创建人：">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入创建人名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-button slot="toolbar" type="primary" size="mini" @click="$refs.releaseFrom.open(0)">新建</el-button>
      <el-table-column type="expand" align="center">
        <template slot-scope="scope">
          <div style="padding-left: 48px">
            <el-table border stripe :data="scope.row.panVOS">
              <el-table-column prop="name" label="资料名称"/>
              <el-table-column prop="guid" label="发布版本">
                <template slot-scope="scope">
                  <span style="color: #2d8cf0; cursor: pointer" @click="downLoad(scope.row.guid)">{{scope.row.guid}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="editableFileGuid" label="可编辑版本">
                <template slot-scope="scope">
                  <span style="color: #2d8cf0; cursor: pointer" @click="downLoad(scope.row.editableFileGuid)">{{scope.row.editableFileGuid}}</span>
                </template>
              </el-table-column>
              <el-table-column width="120" label="操作" align="center">
                <template v-if="scope.row.type === 128" slot-scope="scope">
                  <el-button :disabled="scope.row.status !== 20" type="primary" @click="upOrdownHandle(scope.row)">上架</el-button>
                  <el-button :disabled="scope.row.status !== 30" type="primary" @click="upOrdownHandle(scope.row)">下架</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="billNo" label="编号">
        <template slot-scope="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="$refs.releaseFrom.open(scope.row.pkid, true)">{{scope.row.billNo}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">未提交</span>
          <span v-if="scope.row.status === 10">产品经理待审核</span>
          <span v-if="scope.row.status === 20">产品总监待审核</span>
          <span v-if="scope.row.status === 30">通过</span>
        </template>
      </el-table-column>
      <el-table-column prop="creatorName" label="创建人" align="center" width="100"/>
      <el-table-column prop="createTime" label="创建时间" align="center" width="160"/>
      <el-table-column prop="submitTime" label="提交时间" align="center" width="160"/>
      <el-table-column width="210" label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button :disabled="!!scope.row.status" type="primary" @click="$refs.releaseFrom.open(scope.row.pkid)">编辑</el-button>
          <el-button
              v-if="submitAuth"
              :disabled="!!scope.row.status"
              type="primary"
              :loading="submitLoading"
              @click="submitHandle(scope.row.pkid)"
          >
            提交
          </el-button
          >
          <el-button :disabled="!!scope.row.status" type="danger" @click="deleteHandle(scope.row.pkid)">删除</el-button>
          <el-button v-if="releaseAuth && scope.row.status!==30" :loading="releaseLoading" type="primary" @click="release(scope.row.pkid)">发布</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <release-from ref="releaseFrom" @save-success="getList"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ReleaseFrom from "./ReleaseFrom.vue";
  import loginUtil from "../../../util/loginUtil";
  export default {
    components: { VmTable, VmSearch, ReleaseFrom },
    data() {
      return {
        releaseAuth: this.$auth(649),
        submitAuth: this.$auth(656),
        filter: {
          billNo: "",
          creatorName: loginUtil.getUserInfo().name,
        },
        submitLoading: false,
        releaseLoading: false,
      };
    },

    mounted() {
      this.getList();
    },

    methods: {
      getList() {
        this.$refs.vmTable.getList();
      },

      // 提交
      submitHandle(pkid) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.submitLoading = true;
          this.$http
            .get("basic", `panPublishProcess/submit/${pkid}`)
            .then(() => {
              this.getList();
              this.$message.success("提交成功");
              this.submitLoading = false;
            })
            .catch(() => {
              this.submitLoading = false;
            });
        });
      },
      release(pkid) {
        this.$confirm("确定发布吗?", "提示", { type: "warning" }).then(() => {
          this.releaseLoading = true;
          this.$http
            .get("basic", `panPublishProcess/release/${pkid}`)
            .then(() => {
              this.getList();
              this.$message.success("发布成功");
              this.releaseLoading = false;
            })
            .catch(() => {
              this.releaseLoading = false;
            });
        }); 
      },
      // 删除
      deleteHandle(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "panPublishProcess", pkid).then(() => {
            this.getList();
            this.$message.success("删除成功");
          });
        });
      },

      upOrdownHandle(row) {
        if (row.status === 30) {
          this.$confirm("确定下架吗?", "提示", { type: "warning" }).then(() => {
            this.$http.get("basic", `pans/upAndDown/${row.id}`).then((res) => {
              this.getList();
              this.$message.success("下架成功");
            });
          });
        } else {
          this.$confirm("确定上架吗?", "提示", { type: "warning" }).then(() => {
            this.$http.get("basic", `pans/upAndDown/${row.id}`).then((res) => {
              this.getList();
              this.$message.success("上架成功");
            });
          });
        }
      },

      downLoad(key) {
        this.$http.exportFile("basic", `pans/downLoadFile_V1/${key}`).then((res) => {
          var a = document.createElement("a");
          a.href = res.config.url;
          a.click();
        });
      },
    },
  };
</script>
